import { render, staticRenderFns } from "./HoursWindow2.vue?vue&type=template&id=0b35f4de&"
import script from "./HoursWindow2.vue?vue&type=script&lang=js&"
export * from "./HoursWindow2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports